import React from 'react';
import { CardTitle } from './ui';

/** The AI Fluency Ladder: five stages, each with a pattern and a risk. One source, shown on /why and /compass. */

export const LADDER = [
  ['1', 'AI Aware', '0 to 5 points', 'Passive observation. You follow the news, you have seen the demos, and your opinions come from what you have read.', 'Observation is not preparation. Every major disruption had observers who understood exactly what was happening and still got left behind.'],
  ['2', 'AI Curious', '6 to 20 points', 'Unstructured experimentation. You use AI often, try tools, share prompts. The energy is real. The direction is not yet.', 'Enthusiasm is not a strategy. Curious users move fast and govern nothing, and sensitive data finds unvetted tools before anyone notices.'],
  ['3', 'AI Literate', '21 to 35 points', 'Task-focused efficiency. You use AI every day. The outputs are clean and on time. You have stopped second-guessing every output.', 'This is where the Cognitive Rust Belt begins: where you believe you have arrived. The loop atrophies quietly until the moment that needs judgment.'],
  ['4', 'AI Functional', '36 to 49 points', 'Building solutions. You design with AI: custom workflows, integrated systems. People come to you with questions.', 'Solution fixation. Making a broken process faster, and calling a paved cow path a transformation.'],
  ['5', 'AI Fluent', '50 points', 'A strategic force multiplier. You no longer think about using AI, and the outputs are things neither of you could have produced alone.', 'No stopping here. Treat this stage as an arrival and the regression has begun. Cognitive Agility keeps the milestone from becoming a memory.'],
];

const Ladder = () => (
  <ol className="flex flex-col gap-[14px]">
    {LADDER.map(([n, name, pts, looks, risk]) => (
      <li key={name} className="rounded-lg border border-navy-200 dark:border-navy-700 bg-white dark:bg-navy-850 p-5 md:p-[26px] grid grid-cols-1 md:grid-cols-12 gap-4">
        <div className="md:col-span-3 flex md:flex-col items-baseline md:items-start gap-3">
          <span className="font-sans font-semibold text-stat text-emerald-600 dark:text-emerald-300">{n}</span>
          <div>
            <CardTitle>{name}</CardTitle>
            <div className="font-mono text-meta text-navy-500 dark:text-navy-400">{pts}</div>
          </div>
        </div>
        <div className="md:col-span-5">
          <div className="font-sans text-label uppercase font-semibold text-navy-500 dark:text-navy-400">What it looks like</div>
          <p className="font-sans text-interface mt-1 text-navy-600 dark:text-[#C9D2E0]">{looks}</p>
        </div>
        <div className="md:col-span-4">
          <div className="font-sans text-label uppercase font-semibold text-navy-500 dark:text-navy-400">{n === '5' ? 'The standard' : 'The risk'}</div>
          <p className="font-sans text-interface mt-1 text-navy-600 dark:text-[#C9D2E0]">{risk}</p>
        </div>
      </li>
    ))}
  </ol>
);

export default Ladder;
